// extracted by mini-css-extract-plugin
export var button = "_kc-0";
export var donut = "_kc-1";
export var donutFill = "_kc-3";
export var donutTrack = "_kc-2";